import React, { useState } from "react";
import { connect } from "react-redux";
import operations from "./ducks/operations";
import { Button, CircularProgress } from "@mui/material";
import AssetServicesDeleteModal from "./AssetServicesDeleteModal";

const AssetServicesDeleteModalContainer = (props) => {
    const [modal, toggleModal] = useState(false);
    const { propertyKey, propertyManagementKey } = props;
    return props.saving ? (
        <CircularProgress color="primary" size={20} style={{ marginRight: "40px" }} />
    ) : (
        <React.Fragment>
            <Button variant="contained" color="primary" onClick={() => toggleModal(true)}>
                Delete
            </Button>
            <AssetServicesDeleteModal
                open={modal}
                toggleModal={toggleModal}
                propertyKey={propertyKey}
                propertyManagementKey={propertyManagementKey}
                {...props}
            />
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        propertyManagementKey: state.propertyReducer.propertyManagement.propertyManagementKey,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteAssetServicesRecord: (propertyManagementKey) => {
            dispatch(operations.deleteAssetServicesRecord(propertyManagementKey));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetServicesDeleteModalContainer);
